import React from 'react'
import injectSheet from 'react-jss'
import styles from './examples-section.styles'
import ExamplesEntry from './examples-entry/examples-entry.container'

const ExamplesSection = ({ classes, examples, premium }) => (
  <div className={classes.section}>
    {examples
      .filter(example => example.premium === premium)
      .map(example => (
        <ExamplesEntry key={example.id} id={example.id} />
      ))}
  </div>
)

export default injectSheet(styles)(ExamplesSection)
